import { createFileRoute } from '@tanstack/react-router';

import { buildSeoHead, ROUTE_META } from '@src/corelib/seo';
import { DefaultLayout } from '@src/layout';
import CookiePolicy from '@src/pages/CookiePolicy';

export const Route = createFileRoute('/cookie-policy')({
  head: () => buildSeoHead({ path: '/cookie-policy', ...ROUTE_META['/cookie-policy'] }),
  component: CookiePolicyPageWithLayout,
});

function CookiePolicyPageWithLayout() {
  return (
    <DefaultLayout>
      <CookiePolicy />
    </DefaultLayout>
  );
}
